__turbopack_context__.v({
  "heading": "PlaceholderPrint-module-scss-module__QhXAUW__heading",
  "icon": "PlaceholderPrint-module-scss-module__QhXAUW__icon",
  "printButton": "PlaceholderPrint-module-scss-module__QhXAUW__printButton",
  "text": "PlaceholderPrint-module-scss-module__QhXAUW__text",
  "wrapper": "PlaceholderPrint-module-scss-module__QhXAUW__wrapper",
});
